/**
 * Scryfall serves the same card image in several crops under one id; the art
 * crop is the illustration alone, which is what a report band shows behind
 * its verdicts. Anything that isn't a Scryfall border crop is returned
 * unchanged, and CSS falls back to cropping the full card.
 */
export function artCropUrl(imageUri) {
    if (typeof imageUri !== 'string') return null;
    return imageUri.replace('cards.scryfall.io/border_crop/', 'cards.scryfall.io/art_crop/');
}

const SWIPE_MIN_DISTANCE = 70;
const SWIPE_MAX_DURATION = 600;

/**
 * Classifies a finished touch gesture as a section swipe. It must be quick,
 * long enough, and clearly horizontal, so vertical scrolling and slow drags
 * never switch sections. Returns 'next', 'prev', or null.
 */
export function detectSwipe({ dx, dy, dt }) {
    if (dt > SWIPE_MAX_DURATION) return null;
    if (Math.abs(dx) < SWIPE_MIN_DISTANCE) return null;
    if (Math.abs(dx) < Math.abs(dy) * 2) return null;
    return dx < 0 ? 'next' : 'prev';
}

/**
 * True when a touch starts on something that owns horizontal gestures itself
 * (sliders, inputs, or a region that scrolls sideways), so the section swipe
 * must stay out of its way.
 */
export function ownsHorizontalGesture(target, boundary) {
    for (let el = target; el && el !== boundary; el = el.parentElement) {
        if (el.matches?.('input, textarea, select, [role="slider"], canvas, [data-swipe-ignore]')) return true;
        if (el.scrollWidth > el.clientWidth) {
            const overflowX = getComputedStyle(el).overflowX;
            if (overflowX === 'auto' || overflowX === 'scroll') return true;
        }
    }
    return false;
}
